
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/Payslip.css";
import { FaFileAlt } from "react-icons/fa";
import { Download } from "lucide-react";

const Payslip = () => {
  const navigate = useNavigate();

  // Dummy payslip data
  const [payslips] = useState([
    { month: "January 2025", file: "payslip-jan-2025.pdf" },
    { month: "February 2025", file: "payslip-feb-2025.pdf" },
    { month: "March 2025", file: "payslip-mar-2025.pdf" },
    { month: "April 2025", file: "payslip-apr-2025.pdf" },
    { month: "May 2025", file: "payslip-may-2025.pdf" },
    { month: "June 2025", file: "payslip-jun-2025.pdf" },
    { month: "July 2025", file: "payslip-jul-2025.pdf" },
    { month: "August 2025", file: "payslip-aug-2025.pdf" },
    { month: "September 2025", file: "payslip-sep-2025.pdf" },
    { month: "October 2025", file: "payslip-oct-2025.pdf" },
    { month: "November 2025", file: "payslip-nov-2025.pdf" },
    { month: "December 2025", file: "payslip-dec-2025.pdf" },

    // Example additional year
    { month: "January 2026", file: "payslip-jan-2026.pdf" },
    { month: "February 2026", file: "payslip-feb-2026.pdf" },
    { month: "March 2026", file: "payslip-mar-2026.pdf" },
  ]);

  // Filter states
  const [selectedYear, setSelectedYear] = useState("2025");
  const [fromMonth, setFromMonth] = useState("1");
  const [toMonth, setToMonth] = useState("12");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);

  const payslipsPerPage = 12;

  const months = [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const years = ["2023", "2024", "2025", "2026"];

  // Filter payslips
  const filteredPayslips = payslips.filter((payslip) => {
    const [monthName, year] = payslip.month.split(" ");

    const monthNumber = months.find(
      (month) => month.label === monthName
    )?.value;

    return (
      year === selectedYear &&
      Number(monthNumber) >= Number(fromMonth) &&
      Number(monthNumber) <= Number(toMonth)
    );
  });

  // Calculate pagination
  const totalPages = Math.ceil(
    filteredPayslips.length / payslipsPerPage
  );

  const indexOfLastPayslip = currentPage * payslipsPerPage;
  const indexOfFirstPayslip =
    indexOfLastPayslip - payslipsPerPage;

  const currentPayslips = filteredPayslips.slice(
    indexOfFirstPayslip,
    indexOfLastPayslip
  );

  // Change page
  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
    setCurrentPage(1);
  };

  const handleFromMonthChange = (e) => {
    const value = e.target.value;

    setFromMonth(value);
    setCurrentPage(1);

    // Automatically adjust To month
    if (Number(value) > Number(toMonth)) {
      setToMonth(value);
    }
  };

  const handleToMonthChange = (e) => {
    const value = e.target.value;

    setToMonth(value);
    setCurrentPage(1);

    // Automatically adjust From month
    if (Number(value) < Number(fromMonth)) {
      setFromMonth(value);
    }
  };



  // Download all filtered payslips
const handleDownloadAll = () => {
  if (filteredPayslips.length === 0) {
    alert("No payslips available to download.");
    return;
  }

  filteredPayslips.forEach((payslip, index) => {
    setTimeout(() => {
      const link = document.createElement("a");
      link.href = `/${payslip.file}`;
      link.download = payslip.file;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, index * 500);
  });
};



  const theme = localStorage.getItem("theme") || "simple";

  const ViewPayslip = (payslip) => {
    navigate("/employee/payslip-view", {
      state: { payslip },
    });
  };

  return (
    <div className={`payslip-container theme-${theme}`}>

      {/* Header */}
      <div className="payslip-header">
        <h2>
          <span className="icon">
            <FaFileAlt />
          </span>
          Payslips
        </h2>

        <div className="payslip-header-accent"></div>

        <p className="payslip-subtitle">
          Download your monthly salary slips securely
        </p>
      </div>

      {/* Filter Section */}
      <div className="payslip-filter">

        <div className="filter-group">
          <label>Year</label>

          <select
            value={selectedYear}
            onChange={handleYearChange}
          >
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>From</label>

          <select
            value={fromMonth}
            onChange={handleFromMonthChange}
          >
            {months.map((month) => (
              <option
                key={month.value}
                value={month.value}
              >
                {month.label}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>To</label>

          <select
            value={toMonth}
            onChange={handleToMonthChange}
          >
            {months.map((month) => (
              <option
                key={month.value}
                value={month.value}
              >
                {month.label}
              </option>
            ))}
          </select>
        </div>
        
      {/* Download All Button */}
<div className="download-all-container">
  <button
    className="btn-download-all"
    onClick={handleDownloadAll}
  >
    <Download size={16} />
    Download All
  </button>
</div>

      </div>


      {/* Payslip Cards */}
      <div className="payslip-list">

        {currentPayslips.length > 0 ? (
          currentPayslips.map((payslip, index) => (

            <div
              className="payslip-card"
              key={index}
            >

              <div className="payslip-info">

                <h4>{payslip.month}</h4>

                <p>
                  Payslip available for download
                </p>

              </div>

              <div className="payslip-actions">

                <button
                  className="btn-view"
                  onClick={() => ViewPayslip(payslip)}
                >
                  <FaFileAlt
                    size={16}
                    style={{ marginRight: "6px" }}
                  />
                  View
                </button>

                <a
                  href={`/${payslip.file}`}
                  download
                  className="btn-download"
                >
                  <Download
                    size={16}
                    style={{ marginRight: "6px" }}
                  />
                  Download
                </a>

              </div>

            </div>

          ))
        ) : (

          <div className="no-payslip">
            No payslips available for the selected period.
          </div>

        )}

      </div>

      {/* Pagination */}
   
        <div className="payslip-pagination">

          <button
            className="pagination-btn"
            disabled={currentPage === 1}
            onClick={() => goToPage(currentPage - 1)}
          >
            Previous
          </button>

          {Array.from(
            { length: totalPages },
            (_, index) => index + 1
          ).map((page) => (

            <button
              key={page}
              className={`pagination-number ${
                currentPage === page ? "active" : ""
              }`}
              onClick={() => goToPage(page)}
            >
              {page}
            </button>

          ))}

          <button
            className="pagination-btn"
            disabled={currentPage === totalPages}
            onClick={() => goToPage(currentPage + 1)}
          >
            Next
          </button>

        </div>
      

    </div>
  );
};

export default Payslip;
